// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".clvr-config .clvr-config__establishment_select{max-width:300px}", "",{"version":3,"sources":["webpack://./modules/system/vue/Components/ConfigurationManager/ClvrConfig/ClvrConfig.scss"],"names":[],"mappings":"AACE,gDACE,eAAA","sourcesContent":[".clvr-config {\n  & &__establishment_select {\n    max-width: 300px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
